import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';

import AnswerGraph from "./QuestionAnswerGraph";
import AnswerFooter from "./QuestionAnswerFooter";
import MainHeader from "../layout/MainHeader";
import MainFooter from "../layout/MainFooter";
import Modal from "../global/Modal";
import QuestionBackgroundElement from './QuestionBackgroundElements';

class Question extends Component {
    constructor(props) {
        super(props);

        document.body.className = 'survey survey--question';

        this.defaultError = 'Prosimy odświeżyć stronę lub spróbować później.';
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.hideModal = this.hideModal.bind(this);

        this.state = {
            showAnswer: this.wasAnswered(),
            showError: false,
            isWholeTestDone: false,
            firstSelected: true,
            showTutorial: this.props.showTutorial,
            hoverAnswer: 0,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.q['code'] !== prevProps.q['code']) {
            // check if question was already answered by searching it in global state
            this.setState({ showAnswer: this.wasAnswered(), showError: false });
        }
    }

    wasAnswered() {
        return Object.keys(this.props.test[this.props.selectedArea].answers).includes(this.props.q['code']);
    }

    async handleClick(answer, firstSelected) {
        this.setState({showTutorial: false});
        this.props.dispatch({ type: 'SHOW_TUTORIAL', showTutorial: false });
        await this.makeRequest(answer, firstSelected);
    }

    handleNext() {
        this.nextQuestionNum = this.props.selectedQuestion + 1;
        this.setState({showAnswer: false, showError: false});

        setTimeout( () => {
            if (this.nextQuestionNum === this.props.totalQuestions) {
                this.props.dispatch({ type: 'MAKE_AREA_DONE', area: this.props.selectedArea });
                this.props.dispatch({ type: 'MAKE_TEST_DONE' });

                if (this.props.isEnvironmentDone && this.props.isTechnologyDone && this.props.isEducationDone && this.props.isSocietyDone) {
                    this.setState({isWholeTestDone: true});
                }

                if (this.state.isWholeTestDone) {
                    this.props.history.push('/survey/results');
                } else {
                    this.props.history.push('/survey');
                }
            } else {
                this.props.dispatch({ type: 'SHOW_TUTORIAL', showTutorial: false});
                this.props.dispatch({ type: 'SELECT_QUESTION', value: this.nextQuestionNum });
            }
        }, 300);
    }

    handlePrev() {
        this.prevQuestionNum = this.props.selectedQuestion - 1;
        this.setState({showAnswer: false, showError: false});
        setTimeout( () => {
            this.props.dispatch({type: 'SELECT_QUESTION', value: this.prevQuestionNum});
        }, 300);
    }

    hideModal() {
        this.setState({'showError': false})
    }

    handleMouseOver(num = 0) {
        this.setState({hoverAnswer: num});
    }

    makeRequest(answer, firstSelected) {
        $.ajax({
            url: '/survey-answers',
            data: {
                [this.props.q.code]: answer.id
            },
            success: (data) => {
                if (data.status) {
                    this.showAnswer(answer, firstSelected)
                } else {
                    this.showError(data.error);
                }
            },
            error: (error) => {
                this.showError();
            }
        });
    }

    showAnswer(answer, first) {
        this.props.dispatch({
            type: 'SAVE_ANSWER',
            area: this.props.selectedArea,
            answer: answer,
            first: first,
            code: this.props.q.code,
        });
        this.setState({showAnswer: true, firstSelected: first});
    }

    showError(message = this.defaultError) {
        this.setState({ showError: true, errorMessage: message});
    }

    render() {
        const q = this.props.q;

        const addText = 'Za dwadzieścia lat…';
        const isAddInText = q.text.indexOf(addText) >= 0;

        return (
            <Fragment>
                <MainHeader>
                    {isAddInText && !!q.text.split(addText)[1] &&
                        <p className="add-text">{addText}</p>
                    }
                    <h2>
                        {isAddInText && !!q.text.split(addText)[1] ?
                            q.text.split(addText)[1]
                            :
                            q.text.split(addText)[0] ? q.text.split(addText)[0] : addText
                        }
                    </h2>
                </MainHeader>

                <div className="answers">
                    <div className={`answer__label 
                        ${this.state.hoverAnswer === 1 ? 'over' : ''}
                        ${this.state.showAnswer ? 'answer__answered' : ''}
                    `}
                         onClick={() => this.handleClick(q.answers[0], true)}
                         onMouseOver={() => this.handleMouseOver(1)}
                         onMouseOut={() => this.handleMouseOver()}
                    >
                        { q.answers[0].text }
                    </div>

                    <div className={`answer__graph ${this.state.showTutorial ? 'answer__tutorial' : ''}`}>
                        <AnswerGraph answered={this.state.showAnswer}
                                     one={q.answers[0].percent}
                                     two={q.answers[1].percent}
                                     answerHover={this.state.hoverAnswer}
                                     firstSelected={this.state.firstSelected}
                                     click={(id) => this.handleClick(q.answers[id], id === 0 )}
                                     over={id => this.handleMouseOver(id)}
                                     out={() => this.handleMouseOver()}
                                     showTutorial={this.props.showTutorial}
                        />
                    </div>

                    <div className={`answer__label 
                        ${this.state.hoverAnswer === 2 ? 'over' : ''}
                        ${this.state.showAnswer ? 'answer__answered' : ''}
                    `}
                         onClick={() => this.handleClick(q.answers[1], false)}
                         onMouseOver={() => this.handleMouseOver(2)}
                         onMouseOut={() => this.handleMouseOver()}>
                        { q.answers[1].text }
                    </div>
                    { this.state.showTutorial &&
                        <p className="answer__help"><mark>wybierz odpowiedź</mark></p>
                    }
                    { this.state.showAnswer &&
                    <p className="answer__help answer__help--bottom"><mark>Tyle osób odpowiedziało jak Ty.</mark></p>
                    }
                    <QuestionBackgroundElement selectedQuestion={this.props.selectedQuestion} category={this.props.selectedArea} />
                </div>

                <MainFooter>
                    <AnswerFooter name={this.props.name} showHint={this.state.showAnswer} next={this.handleNext} prev={this.handlePrev} />
                </MainFooter>

                <Modal show={this.state.showError} additionalClass="error" close={this.hideModal}>
                    <h4 className="error__heading">Wystąpił błąd</h4>
                    <p>{this.state.errorMessage}</p>
                </Modal>

            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        q: state.survey[state.globals.selectedArea].questions[state.globals.selectedQuestion],
        test: state.test,
        name: state.survey[state.globals.selectedArea].name,
        token: state.globals.token,
        isEnvironmentDone: state.test.environment.done,
        isTechnologyDone: state.test.technology.done,
        isEducationDone: state.test.education.done,
        isSocietyDone: state.test.society.done,
        selectedArea: state.globals.selectedArea,
        selectedQuestion: state.globals.selectedQuestion,
        totalQuestions: state.globals.totalQuestions,
        showTutorial: state.globals.showTutorial,
    };
};

export default connect(mapStateToProps)(Question);


// WEBPACK FOOTER //
// ./sources/js/components/Question/index.js